// src/components/public/CompetitionPublicCard.js
import React from 'react';
import PropTypes from 'prop-types';
// OJO: ajusta la ruta real del componente:
import CompetitionCard from '../gestion/CompetitionCard';

// Tarjeta pública: misma UI que CompetitionCard pero sin estado/inscritos/ajustes
const CompetitionPublicCard = ({ competencia }) => (
  <CompetitionCard
    competencia={competencia}
    hideStatusChip
    hideEnrolledCount
    hideSettings
  />
);

CompetitionPublicCard.propTypes = {
  // Aquí “competencia” ya viene en el shape que espera CompetitionCard (con .general y .location)
  competencia: PropTypes.shape({
    id: PropTypes.string.isRequired,
    slug: PropTypes.string,
    general: PropTypes.shape({
      nombre: PropTypes.string,
      fechaInicioCompetencia: PropTypes.string,
      fechaFinCompetencia: PropTypes.string,
      fechaFinInscripciones: PropTypes.string,
      imagenPortada: PropTypes.string,
      precioInscripciones: PropTypes.number,
      estado: PropTypes.oneOf(['publicado', 'pendiente', 'cancelado', 'finalizado']),
      tipoCompetencia: PropTypes.oneOf(['ruta', 'pista_y_campo', 'campo_traviesa', 'otros']),
    }),
    location: PropTypes.shape({
      lugar: PropTypes.string,
      mapShortLink: PropTypes.string,
    }),
  }).isRequired,
};

export default CompetitionPublicCard;
